import {
	type DiscardFloatingTimeEntryMutation,
	type LinkFloatingTimeEntryMutation,
	type StartFloatingTimerMutation,
	type StopFloatingTimerMutation
} from "~/gql/mutations/events/floatingTimeEntries.generated";
import {
	type ActivateTaskEventTypeMutation,
	type CreateTaskEventTypeMutation,
	type DeleteTaskEventTypeMutation,
	type InactivateTaskEventTypeMutation,
	type UpdateTaskEventTypeMutation
} from "~/gql/mutations/events/taskEventTypes.generated";
import {
	type GetTaskAssignmentQuery,
	type GetTaskAssignmentsQuery,
	type GetTaskPlannedMoveQuery
} from "~/gql/queries/events/taskAssignments.generated";
import { type GetTaskEventTypesQuery } from "~/gql/queries/events/taskEventTypes.generated";

// Task assignment mutations (Create, Start, Complete, Cancel, Reassign, AddNote)
// are in eventsPaginatedApi.ts with onQueryStarted cache patching.
// GetMyTaskAssignments lives in eventsPaginatedApi.ts because it is
// cursor-paginated and needs merge/serializeQueryArgs/forceRefetch — providesTags
// would clobber the accumulated page list on every refetch.

export const eventsEndpoints = {
	ActivateTaskEventType: {
		invalidatesTags: ["TaskEventTypes"] as AddTagTypes,
		transformResponse: (res: ActivateTaskEventTypeMutation) => res
	},
	CreateTaskEventType: {
		invalidatesTags: ["TaskEventTypes"] as AddTagTypes,
		transformResponse: (res: CreateTaskEventTypeMutation) => res
	},
	DeleteTaskEventType: {
		invalidatesTags: ["TaskEventTypes"] as AddTagTypes,
		transformResponse: (res: DeleteTaskEventTypeMutation) => res
	},
	DiscardFloatingTimeEntry: {
		invalidatesTags: ["FloatingTimeEntries", "TaskAssignments"] as AddTagTypes,
		transformResponse: (res: DiscardFloatingTimeEntryMutation) => res
	},
	GetTaskAssignment: {
		providesTags: ["TaskAssignments"] as AddTagTypes,
		transformResponse: (res: GetTaskAssignmentQuery) => res
	},
	GetTaskAssignments: {
		providesTags: ["TaskAssignments"] as AddTagTypes,
		transformResponse: (res: GetTaskAssignmentsQuery) => res
	},
	GetTaskPlannedMove: {
		providesTags: ["TaskAssignments"] as AddTagTypes,
		transformResponse: (res: GetTaskPlannedMoveQuery) => res
	},
	GetTaskEventTypes: {
		providesTags: ["TaskEventTypes"] as AddTagTypes,
		transformResponse: (res: GetTaskEventTypesQuery) => res
	},
	InactivateTaskEventType: {
		invalidatesTags: ["TaskEventTypes"] as AddTagTypes,
		transformResponse: (res: InactivateTaskEventTypeMutation) => res
	},
	LinkFloatingTimeEntry: {
		invalidatesTags: ["FloatingTimeEntries", "TaskAssignments"] as AddTagTypes,
		transformResponse: (res: LinkFloatingTimeEntryMutation) => res
	},
	StartFloatingTimer: {
		invalidatesTags: ["FloatingTimeEntries"] as AddTagTypes,
		transformResponse: (res: StartFloatingTimerMutation) => res
	},
	StopFloatingTimer: {
		invalidatesTags: ["FloatingTimeEntries"] as AddTagTypes,
		transformResponse: (res: StopFloatingTimerMutation) => res
	},
	UpdateTaskEventType: {
		invalidatesTags: ["TaskEventTypes"] as AddTagTypes,
		transformResponse: (res: UpdateTaskEventTypeMutation) => res
	}
};
